export default "__VITE_ASSET__D_ZpHto8__"